import React from "react";
import HStack from "../layout/HStack";

type Props = {
  content: string;
};

const EmptyData = ({ content }: Props) => {
  return (
    <HStack className="w-full py-2" justifyContent="center">
      <p className="px-2 py-[6px] text-sm font-semibold">{content}</p>
    </HStack>
  );
};

export default EmptyData;
